module.exports = __webpack_public_path__ + "img/zhszjy.cb854833.png";